import { addEllipsis, shortenLength } from './string';
import { FILE_NAME_MAX_LENGTH } from '../constants';
import pdfIcon from '../assets/images/pdf-icon.png';
import excelIcon from '../assets/images/excel-icon.svg';
import fileIcon from '../assets/images/file-icon.png';

function getFileDataByType(name: string, type: string) {
  const nameSplitted = name?.split('.');
  const extension = nameSplitted.pop();
  let nameFormatted = name;
  if (name?.length > FILE_NAME_MAX_LENGTH) {
    nameFormatted = `${addEllipsis(
      shortenLength(nameSplitted.join('.'), FILE_NAME_MAX_LENGTH)
    )}${extension}`;
  }
  switch (type) {
    case 'application/pdf':
      return { name: nameFormatted, icon: pdfIcon };
    case 'application/vnd.ms-excel':
      return { name: nameFormatted, icon: excelIcon };
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return { name: nameFormatted, icon: excelIcon };
    default:
      return { name: nameFormatted, icon: fileIcon };
  }
}

function getFileSizeMB(size: number): number {
  return size / 1024 ** 2; // convertion to MB
}

export { getFileDataByType, getFileSizeMB };
